import { Outlet, Navigate } from "react-router-dom";
import { useEffect } from "react";
import TwoFactorAuth from "./private_page/RestrictedPages/TwoFactorAuth";
import SelectAccount from "./private_page/RestrictedPages/SelectAccount";
import { ListLoader } from "./Hooks/PageLoader";
import { useApp } from "./APIHelpers/AppContext";

const AllPermission = () => {
  const { auth, getCurrectLoginUser, currentUserData, organizationList, isDark } = useApp();
  useEffect(() => {
    if (auth && !currentUserData) {
      getCurrectLoginUser();
    }
  }, [auth, currentUserData, getCurrectLoginUser]);
  
  if (auth) {
    if (!currentUserData) {
      return <div style={{ height: "100vh" }}><ListLoader /></div>;
    }
    if (currentUserData?.twoFA) {
      return <TwoFactorAuth auth={auth} currentUserData={currentUserData} isDark={isDark} />;
    }
    if (!currentUserData?.loginAccountId && currentUserData?.roleType === "organization") {
      return <SelectAccount auth={auth} organizationList={organizationList} currentUserData={currentUserData} getCurrectLoginUser={getCurrectLoginUser} accountId={currentUserData?.loginAccountId} isDark={isDark} />;
    }
    return <Outlet />;
  }

  return <Navigate to="/login" />;
};

const LoginPermission = () => {
  const { auth } = useApp();
  if (!auth) {
    return <Outlet />;
  } else {
    return <Navigate to="/home" />;
  }
};

export const Permission = {
  LoginPermission,
  AllPermission,
};